const RequestQueueManager = (axios) => {
    let instance = {
        queue: [],
        running: [],
        pending: () => {
            return instance.queue.length + instance.running.length;
        },
        shiftInitial: () => {
            setTimeout(() => {
                if (instance.running.length < 1) {
                    instance.prioritise();
                    instance.shift();
                }
            }, 0);
        },
        prioritise: () => {
            // We want to remove duplicate summary requests and move the
            // remaining summary request to the end of the queue...

            let isSummaryRequest = reqHandler => {
                return reqHandler.request.url.startsWith('/api/orders/')
                    && reqHandler.request.url.endsWith('/summary');
            };

            let summaryRequestHandler = instance.queue.find(isSummaryRequest);

            if (summaryRequestHandler) {
                instance.queue = instance.queue.filter(reqHandler => {
                    return isSummaryRequest(reqHandler) === false;
                });
                instance.queue.push(summaryRequestHandler);
            }
        },
        push: reqHandler => {
            instance.queue.push(reqHandler);
            instance.shiftInitial();
        },
        shift: () => {
            window.store.misc.syncRequestsPending = instance.pending();

            if (instance.pending() == 0) {
                window.bus.$emit('request-queue-empty');
            }

            // window.console.log(`queued: ${instance.queue.length}`, `running: ${instance.running.length}`);
            if (instance.queue.length) {
                const queued = instance.queue.shift();
                queued.resolver(queued.request);
                instance.running.push(queued);
            }
        },
        // Use as interceptor. Queue outgoing requests
        requestHandler: req => {
            return new Promise(resolve => {
                instance.push({ request: req, resolver: resolve });
            });
        },
        // Use as interceptor. Execute queued request upon receiving a response
        responseHandler: res => {
            instance.running.shift();
            instance.shift();
            return res;
        },
        interceptors: {
            request: null,
            response: null
        },
        detach: () => {
            axios.interceptors.request.eject(instance.interceptors.request);
            axios.interceptors.response.eject(instance.interceptors.response);
        }
    };

    // Queue concurrent requests
    instance.interceptors.request = axios.interceptors.request.use(
        instance.requestHandler
    );
    instance.interceptors.response = axios.interceptors.response.use(
        instance.responseHandler,
        instance.responseHandler
    );

    return instance;
};

module.exports = {
    RequestQueueManager
};
